import React from 'react';

interface ApplicationSummaryData {
    id: string;
    serviceType: string;
    assignedLawyer: string;
    status: string;
}

interface ApplicationSummaryCardProps {
    data: ApplicationSummaryData;
}

const ApplicationSummaryCard: React.FC<ApplicationSummaryCardProps> = ({ data }) => {
    return (
        <div className="application-summary-card">
            <div className="summary-grid">
                <div className="summary-item">
                    <div className="summary-label">ID</div>
                    <div className="summary-value">{data.id}</div>
                </div>
                
                <div className="summary-item">
                    <div className="summary-label">Tipo de servicio</div>
                    <div className="summary-value">{data.serviceType}</div>
                </div>
                
                <div className="summary-item">
                    <div className="summary-label">Abogado asignado</div>
                    <div className="summary-value">{data.assignedLawyer}</div>
                </div>
                
                <div className="summary-item">
                    <div className="summary-label">Estado</div>
                    <div className="summary-value">
                        <span className="status-indicator">
                            <span className="status-dot"></span>
                            {data.status}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ApplicationSummaryCard;
